export default __webpack_public_path__ + "static/media/MuseoSansRounded-500.78fd1064.woff2";